import { ws } from "../../../utils/common";

export const getExploreEventsWS = async ({ limit }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/",
    { limit },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
